var _defs, _style, _linearGradient;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDwollaLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 63.999999",
    id: "svg15",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs19"
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".st0{fill:#2d2d48}")), _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 2.4820001,
    y1: 77.792,
    x2: 73.968002,
    y2: 6.3060002,
    gradientTransform: "matrix(0.75014318,0,0,0.75014318,3.784112,-3.575e-4)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f3904a",
    id: "stop8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#aa437f",
    id: "stop10"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M 58.339029,14.625185 33.878358,0.5029875 a 3.7559671,3.7559671 0 0 0 -3.755217,0 L 5.6617204,14.625185 a 3.7552168,3.7552168 0 0 0 -1.8776076,3.25262 v 28.24439 c 0,1.342006 0.7156368,2.581993 1.8776076,3.252623 L 30.122392,63.497012 a 3.7559671,3.7559671 0 0 0 3.755217,0 L 58.338277,49.374818 a 3.7552168,3.7552168 0 0 0 1.87761,-3.252623 v -28.24439 a 3.7529665,3.7529665 0 0 0 -1.876858,-3.25262 z M 15.964938,24.938904 V 41.258268 L 7.5400795,46.122195 V 17.877805 L 32.000751,3.7556095 v 9.7571115 l -14.157454,8.173562 a 3.7559671,3.7559671 0 0 0 -1.878359,3.252621 z m 14.157454,3.808474 a 3.7552168,3.7552168 0 0 0 -1.877608,3.252624 v 16.262352 l -8.523876,4.920939 V 24.938904 L 44.181575,10.816707 V 20.63083 Z M 56.46067,46.122195 32.000751,60.244393 V 32.000002 L 56.461418,17.877805 Z",
    id: "path13",
    style: {
      fill: "url(#SVGID_1_)",
      strokeWidth: 0.75014323
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDwollaLogo);
export default __webpack_public_path__ + "static/media/dwolla_logo.1e6a719003e0adc38ff8ab455ace6929.svg";
export { ForwardRef as ReactComponent };